/**
 * Storynity application fallbacks (Shadow Realm slate).
 * Not Collabajam brand — Studio must pass its own AdventureStyleInput.
 */
export const DEFAULT_STYLE = {
    background_gradient: ['#1e293b', '#334155', '#475569'],
    gradient_angle: 135,
    button_color: '#64748b',
};
/** Prebuilt CSS for {@link DEFAULT_STYLE} background (used as invalid-input fallback). */
export const DEFAULT_GRADIENT_CSS = 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%)';
export function getDefaultStyle() {
    const style = {
        background_gradient: [...DEFAULT_STYLE.background_gradient],
        button_color: DEFAULT_STYLE.button_color,
    };
    if (DEFAULT_STYLE.gradient_angle !== undefined) {
        style.gradient_angle = DEFAULT_STYLE.gradient_angle;
    }
    return style;
}
export function getDefaultGradient() {
    return DEFAULT_GRADIENT_CSS;
}
export function getDefaultButtonColor() {
    return DEFAULT_STYLE.button_color;
}
//# sourceMappingURL=defaults.js.map